module.exports = __webpack_public_path__ + "media/stylesheets/flag-icon-css/flags/1x1/ma-3b79aff17ae55b760333c9c11e2e1998.svg";